<template>
  <v-form direction="horizontal" :model="form" :rules="formRules" ref="formRef">
    <v-form-item label="Name of College" :label-col="{span: 6}" :wrapper-col="{span: 14}"
      prop="college_name">
      <v-input size="large" v-model="form.college_name" placeholder="Name of College"></v-input>
    </v-form-item>
    <v-form-item label="Level of Education" :label-col="{span: 6}" :wrapper-col="{span: 14}"
      prop="level_of_education">
      <v-select placeholder="Level of Education" size="large" v-model="form.level_of_education"
        :data="optionsStudyLevels" @change="(value) => selectChange('level_of_education', value)"></v-select>
    </v-form-item>
    <v-form-item label="Area of Education" :label-col="{span: 6}" :wrapper-col="{span: 14}"
      prop="area_of_education">
      <v-select placeholder="Area of Education" size="large" v-model="form.area_of_education"
        :data="optionsStudyAreas" @change="(value) => selectChange('area_of_education', value)"></v-select>
    </v-form-item>
    <v-form-item label="Percentage" :label-col="{span: 6}" :wrapper-col="{span: 14}"
      prop="percentage">
      <v-input size="large" v-model="form.percentage" placeholder="Percentage"></v-input>
    </v-form-item>
  </v-form>
</template>

<script>
export default {
  name: 'EducationalDetails',
  data () {
    return {
      optionsStudyLevels: [{
        label: 'Grade-10',
        value: 'G10'
      }, {
        label: 'Grade-12',
        value: 'G12'
      }, {
        label: '1-Year Post-Secondary Certificate',
        value: 'D1'
      }, {
        label: '2-Year Undergraduate Diploma',
        value: 'D2'
      }, {
        label: '3-Year Undergraduate Advanced Diploma',
        value: 'D3'
      }, {
        label: '4-Year Bachelor\'s Degree',
        value: 'B4'
      }, {
        label: 'Postgraduate Certificate / Master\'s Degree',
        value: 'PG'
      }],
      optionsStudyAreas: [],
      form: {
        college_name: null,
        level_of_education: null,
        area_of_education: null,
        percentage: null
      },
      formRules: {
        college_name: [{
          required: true,
          message: '* Required'
        }],
        level_of_education: [{
          required: true,
          message: '* Required'
        }],
        area_of_education: [{
          required: true,
          message: '* Required'
        }],
        percentage: [{
          required: true,
          message: '* Required'
        }]
      }
    }
  },
  methods: {
    selectChange (key, val) {
      this.form[key] = val
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // this.$store.dispatch('addProgram', this.form)
        } else {
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Student/Profile/EducationalDetails.vue